// extracted by mini-css-extract-plugin
export default {"player":"playerSelect_player__tV7Xo","active":"playerSelect_active__FEvJK","male":"playerSelect_male__4rLkK","female":"playerSelect_female__c+VJ2","name":"playerSelect_name__A+fq1"};